/**
 * Courses spéciales business service
 */
angular.module("exploitation").factory("CoursesSpecialesService", ["$http", "ENV", function ($http, ENV) {


	/**
     * API
     */
	var api = {
		getCoursesSpeciales: getCoursesSpeciales,
		getCoursesSpecialesToday: getCoursesSpecialesToday,
		postCourseSpeciale: postCourseSpeciale,
		deleteCourse: deleteCourse,
		getCourseSpeciale: getCourseSpeciale,
		putCourseSpeciale: putCourseSpeciale,
		duplicateCourseSpeciale: duplicateCourseSpeciale
	};


	/**
     * Récupérer une course
     * @param id
     * @returns {HttpPromise}
     */
	function getCourseSpeciale(id, useCache) {
		return $http.get(ENV.API_URL + "/special-course/" + id,
			{
				cache: useCache ? useCache : false
			});
	}

	/**
     * Dupliquer une course et ses étapes
     * @param id
     * @returns {HttpPromise}
     */
	function duplicateCourseSpeciale(id) {
		return $http.get(ENV.API_URL + "/special-course/duplicate/" + id);
	}

	/**
     * Récupérer toutes les courses spéciales après la date
     *
     * @returns {*}
     */
	function getCoursesSpeciales(date) {
		return $http.get(ENV.API_URL + "/special-course/after-date/" + date);
	}

	/**
   * Récupérer toutes les courses spéciales de la journée
   *
   * @returns {*}
   */
	function getCoursesSpecialesToday() {
		return $http.get(ENV.API_URL + "/special-course/today");
	}

	/**
     * Créer une nouvelle course spéciale
     * @param data
     * @returns {HttpPromise}
     */
	function postCourseSpeciale(data) {
		return $http.post(ENV.API_URL + "/special-course", data);
	}

	/**
     * Mettre à jour une course spéciale
     * @param data
     * @returns {HttpPromise}
     */
	function putCourseSpeciale(data) {
		return $http.put(ENV.API_URL + "/special-course/" + data.id, data);
	}

	/**
     * Supprimer une course
     * @param data
     * @returns {HttpPromise}
     */
	function deleteCourse(data) {
		return $http.delete(ENV.API_URL + "/special-course/" + data.id);
	}

	return api;
}]);
